<script>
import getISODay from "date-fns/getISODay";
import formatDay from "@utils/format-day";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";
import 'slick-carousel/slick/slick.css'
import { HOME_TIME_LIST } from "@src/config/reservation";
import formatTextUpperCasefirst from "@utils/format-text-upper-casefirst";

const DEFAULT_PAGE_COUNT = 1;

export default {
  components: {
    Slick: () => import("vue-slick"),
    SlickPagination: () => import("@components/Slick/SlickPagination"),
  },
  props: {
    storeItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: true,
      toDayDay: getISODay(new Date()),

      pageCount: DEFAULT_PAGE_COUNT,
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        initialSlide: DEFAULT_PAGE_COUNT - 1,
        arrows: true,
        centerPadding: '0px',
        touchThreshold: 6,
        centerMode: false,
        dots: false,
        asNavFor: `.imageListB`,
        nextArrow: '<button type="button" class="slick-next"></button>',
        prevArrow: '<button type="button" class="slick-prev"></button>'
      },

      slickOptions2: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        initialSlide: DEFAULT_PAGE_COUNT - 1,
        arrows: true,
        centerPadding: '0px',
        touchThreshold: 6,
        centerMode: true,
        dots: false,
        asNavFor: `.imageList`,
        focusOnSelect: true,
        nextArrow: '<button type="button" class="slick-next"></button>',
        prevArrow: '<button type="button" class="slick-prev"></button>'
      },

      homeTimeList: HOME_TIME_LIST
    }
  },
  computed: {
    currentImageItem() {
      return this.storeItem.images[this.pageCount - 1] || ''
    },
  },
  methods: {
    formatDay,
    formatTextUpperCasefirst,
    getServiceTimeSetting(storeItem) {
      return storeItem.params.serviceTimeSetting['1']
    },
    getAddressRestrictions(storeItem) {
      const reduceIsEventList = storeItem.params.addressRestrictions.reduce((prev, curr) => {
        return [
          ...prev.district,
          ...curr.district
        ]
      });

      return reduceIsEventList
    },
    openDialogLine({
      storeTitle,
      lineId,
      lineFriendUrl
    }) {
      if(this.$globalIsMobileDevice && lineFriendUrl) {
        window.open(lineFriendUrl)
      } else {
        this.$globalDialog('DialogLine', {
          storeTitle,
          lineId,
          lineFriendUrl
        });
      }
    },
    getDefaultImage(images) {
      const defaultImageItems = images.filter(image => image.default) || [];

      return defaultImageItems[0]?.path || '';
    },
    onSlideTo(index) {
      this.$refs.slick.goTo(index - 1)
    },
    onBeforeChange(event, slick, currentSlide, nextSlide) {
      this.pageCount = nextSlide + 1
    },
    openFancybox() {
      const imageList = this.storeItem.images.map(item => {
        return {
          src: item.path,
          thumb: item.path,
          caption: "",
        }
      });

      Fancybox.show(imageList, {
        mainClass: 'isStyleJtails',
        Toolbar: {
          display: [
            { id: "prev", position: "center" },
            { id: "counter", position: "center" },
            { id: "next", position: "center" },
            "close",
          ],
        },
      });

      Fancybox.getInstance().jumpTo(this.pageCount - 1);
    },
    formatPhonenumber(phonenumber = '') {
      const [code, number] = phonenumber.split('-');

      return number
        ? phonenumber
        : ''
    }
  }
}
</script>
<!-- section template -->
<template>
  <section
    class="section"
    :class="[$style.storeSection, $style[`isStyle${formatTextUpperCasefirst(type)}`], { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]"
  >
    <div class="container">
      <div class="row storeSection__contentBox">
        <div class="col-lg-5 storeSection__contentLeft">
          <template v-if="!!storeItem.images[0]">
            <Slick
              ref="slick"
              :options="slickOptions"
              class="slick isStyleBase imageList storeSection__imageList"
              :class="[$style.imageList, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]"
              @beforeChange="onBeforeChange"
            >
              <div
                v-for="(imageItem, index) in storeItem.images"
                :key="`imageList-${index}`"
                class="imageList__item"
                :style="{ backgroundImage: `url('${ imageItem.path || require('@assets/images/default/store-default-Image@2x.png') }')` }"
              ></div>
            </Slick>
            <SlickPagination
              v-model="pageCount"
              :total="storeItem.images.length"
              class="storeSection__pagination d-lg-none"
              type="white"
              @change="onSlideTo"
            />
          </template>
          <template v-else>
            <div
              class="storeSection__defaultImageBox">
              <div class="storeSection__defaultImage"></div>
            </div>
          </template>
          <!--<div class="storeSection__imageBox">
            <div class="storeSection__image" @click="openFancybox">
              <template v-for="(imageItem, index) in storeItem.images">
                <div
                  :key="`imageList-${index}`"
                  class="storeSection__imageInner"
                  :class="{ isActive: index === pageCount - 1 }"
                  :style="{ backgroundImage: `url('${ imageItem.path || require('@assets/images/default/store-default-Image@2x.png') }')` }"
                >
                </div>
              </template>
            </div>
          </div>-->
        </div>
        <div class="col-lg-7 storeSection__contentRight">
          <div class="storeSection__contentRightInner">
            <div>
              <BaseSectionTitleJtails
                v-if="type === 'home'"
                title="分店資訊"
                :sub-title="$globalIsDingBeauty ? 'STORES' : 'stores'"
                class="text-left mt-lg-0 mt-3"
              />
              <div class="d-flex align-items-center justify-content-between mb-2">
                <BaseSectionTitleJtails
                  :title="storeItem.title"
                  :title-class="!$globalIsDingBeauty ? '' : 'isStyleDNone'"
                />
                <ul
                  v-if="!!storeItem.fbFanpageUrl || !!storeItem.lineFriendUrl"
                  :class="[$style.socialList, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]"
                >
                  <li
                    v-if="!!storeItem.fbFanpageUrl"
                    class="socialList__item"
                  >
                    <BaseButton
                      class="isStylePrimary isText3"
                      :class="{ isStyleSecondary: $globalIsDingBeauty }"
                      :href="storeItem.fbFanpageUrl"
                      target="_blank"
                    >
                      <i :class="`fontello ${$globalIsDingBeauty ? 'fontello-db-facebook' : 'fontello-facebook'} fa-2x`"></i>
                    </BaseButton>
                  </li>
                  <li
                    v-if="!!storeItem.lineId || !!storeItem.lineFriendUrl"
                    class="socialList__item"
                  >
                    <template v-if="$globalIsMobileDevice">
                      <BaseButton
                        v-if="storeItem.lineFriendUrl"
                        class="isStylePrimary isText3"
                        :class="{ isStyleSecondary: $globalIsDingBeauty }"
                        :href="storeItem.lineFriendUrl"
                        target="_blank"
                      >
                        <i class="fontello fontello-line fa-2x"></i>
                      </BaseButton>
                    </template>
                    <template v-else>
                      <BaseButton
                        class="isStylePrimary isText3"
                        :class="{ isStyleSecondary: $globalIsDingBeauty }"
                        @click="openDialogLine({ storeTitle: storeItem.title, lineId: storeItem.lineId, lineFriendUrl: storeItem.lineFriendUrl })"
                      >
                        <i class="fontello fontello-line fa-2x"></i>
                      </BaseButton>
                    </template>
                  </li>
                </ul>
              </div>
              <div v-if="$globalIsJtails" class="mb-2">
                <el-tag
                  class="isStylePrimary isSmall2 mr-2"
                >
                  寵物美容
                </el-tag>
              </div>
              <ul :class="[$style.metaList , { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]" >
                <li
                  v-if="!!formatPhonenumber(storeItem.phoneNumber)"
                  class="metaList__item"
                >
                  <a
                    :href="`tel:${ formatPhonenumber(storeItem.phoneNumber) }`"
                    class="metaList__link"
                  >
                    <i class="metaList__icon fontello fontello-phone fa-fw"></i>
                    <span class="metaList__text">{{ formatPhonenumber(storeItem.phoneNumber) }}</span>
                  </a>
                </li>
                <template v-if="!storeItem.storeType || storeItem.storeType === 'store'">
                  <li
                    v-if="!!storeItem.fullAddress"
                    class="col-12 metaList__item"
                  >
                    <a
                      :href="`https://www.google.com.tw/maps/search/${ storeItem.fullAddress }`"
                      class="metaList__link"
                      target="_blank"
                    >
                      <i class="metaList__icon fontello fontello-locate fa-fw"></i>
                      <span class="metaList__text">{{ storeItem.fullAddress }}</span>
                    </a>
                  </li>
                  <li
                    v-if="!!storeItem.params.serviceTimeSetting[toDayDay].start && !!storeItem.params.serviceTimeSetting[toDayDay].end"
                    class="metaList__item"
                  >
                    <el-popover
                      v-if="show"
                      placement="bottom-start"
                      :trigger="$globalBreakpoint === 'xs' || $globalBreakpoint === 'sm' || $globalBreakpoint === '2sm' || $globalBreakpoint === 'md' ? 'click' : 'hover'"
                      content=""
                    >
                      <div
                        slot="reference"
                        class="metaList__link"
                      >
                        <i class="metaList__icon fontello fontello-info fa-fw"></i>
                        <span class="metaList__text">
                          <span>今日</span>
                          <span
                            v-if="!!storeItem.params.serviceTimeSetting[toDayDay].isOpen"
                            class="font-number"
                          >營業時間
                            {{
                              storeItem.params.serviceTimeSetting[toDayDay].start
                            }}-{{ storeItem.params.serviceTimeSetting[toDayDay].end }}</span>
                        <span v-else>不營業</span>
                        </span>
                        <i class="fontello fontello-down fa-sm metaList__textIcon ml-1"></i>
                      </div>
                      <div>
                        <ul :class="$style.dayList">
                          <li
                            v-for="(dayItem, key, index2) in storeItem.params.serviceTimeSetting"
                            :key="index2"
                            class="dayList__item"
                            :class="{ isActive: toDayDay.toString() === key }"
                          >
                            <span class="dayList__title">{{ formatDay(key) }}</span>
                            <span
                              v-if="!!dayItem.isOpen"
                              class="dayList__time"
                            >{{
                                storeItem.params.serviceTimeSetting[key].start
                              }}-{{ storeItem.params.serviceTimeSetting[key].end }}</span>
                            <span v-else>不營業</span>
                          </li>
                        </ul>
                      </div>
                    </el-popover>
                  </li>
                </template>
                <template v-if="storeItem.storeType === 'home'">
                  <li
                    v-if="!!storeItem.params && !!storeItem.params.addressRestrictions[0]"
                    class="col-12 metaList__item"
                  >
                    <div
                      class="metaList__link"
                    >
                      <i class="metaList__icon fontello fontello-info fa-fw"></i>
                      <span class="metaList__text">
                      <span class="pb-2 d-block">服務範圍（目前到府服務僅提供下列地區）</span>
                        <ul :class="$style.areaList">
                          <li
                            v-for="(areaItem, key, index2) in storeItem.params.addressRestrictions"
                            :key="index2"
                            class="areaList__item"
                            :class="{ isActive: toDayDay.toString() === key }"
                          >
                            <span class="areaList__title">{{ areaItem.city }}</span>
                            <span class="areaList__text">
                              {{ areaItem.district.join(', ') }}
                            </span>
                          </li>
                        </ul>
                    </span>
                    </div>
                  </li>
                  <li
                    class="col-12 metaList__item"
                  >
                    <div
                      class="metaList__link"
                    >
                      <i class="metaList__icon fontello fontello-locate fa-fw"></i>
                      <span class="metaList__text">
                      <span class="pb-1 d-block">到府時段</span>
                      {{ homeTimeList.join(' | ') }}
                    </span>
                    </div>
                  </li>
                </template>
              </ul>
            </div>
            <div>
              <Slick
                v-if="!!storeItem.images[0]"
                ref="slick2"
                :options="slickOptions2"
                class="slick isStyleBase imageListB storeSection__imageListB d-none d-lg-block"
                :class="$style.imageListB"
                @beforeChange="onBeforeChange"
              >
                <div
                  v-for="(imageItem, index) in storeItem.images"
                  :key="`imageListB-${index}`"
                  class="imageListB__item"
                  :class="{ isActive: index === pageCount - 1 }"
                  :style="{ backgroundImage: `url('${ imageItem.path || require('@assets/images/default/store-default-Image@2x.png') }')` }"
                ></div>
              </Slick>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<!-- section style -->
<style lang="scss" module>
.storeSection {
  position: relative;

  &::before {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 9.5rem;
    left: 0;
    content: '';
    background-image: linear-gradient(to right, rgba($color-primary, 0.1), rgba($color-primary, 0.1)), url('@assets/images/layout/bg-marble.jpg');
    background-position: center;
    background-size: cover;

    @include max-lg {
      bottom: 0;
    }
  }
  &.isStyleHome {
    &::before {
      display: none;
    }
  }
  &.isStyleDingBeauty {
    &::before{
      background-image: none;
      background-color: $color-bg-default;
    }
    :global {
      .storeSection {
        &__imageList {
          box-shadow: none;
          @include leftBottomStyle()
        }
        &__contentLeft {
          @include max-lg {
            margin-bottom: 2rem;
          }
        }
      }
    }
  }

  :global {
    .storeSection {
      &__contentBox {
        display: flex;
      }

      &__contentLeft {
        position: relative;
      }

      &__contentRight {
        @include unstyled;
      }

      &__contentRightInner {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        padding-left: 4rem;

        @include max-xl {
          padding-left: 1rem;
        }

        @include max-lg {
          padding-left: 0;
        }
      }

      &__imageBox {
        margin-left: calc(((-100vw + #{$container}) / 2) - #{$container-gap});
      }

      &__defaultImageBox {
        margin-left: calc(((-100vw + #{$container}) / 2) - #{$container-gap});
      }

      &__defaultImage {
        position: relative;
        padding-top: 56.5%;
        background-image: url('~@assets/images/default/store-default-Image@2x.png');
      }

      &__image {
        position: relative;
        padding-top: 56.5%;
      }

      &__imageInner {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
        opacity: 0;
        transition: opacity 0.3s;

        &.isActive {
          opacity: 1;
        }
      }

      &__imageList {
        background: $color-bg-default;
        box-shadow: 0 5px 40px #00000029;
      }

      &__imageListB {
        // background: $color-bg-default;
      }

      &__pagination {
        position: absolute;
        bottom: 2rem;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}

.socialList {
  @include list-unstyled;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  @include max-lg {
    padding-top: 0;
    margin-bottom: 0;
    i {
      font-size: 2rem;
    }
  }

  :global {
    .socialList {
      &__item {
        font-size: 1rem;

        @include max-lg {
          // margin-right: 1rem;
        }

        &:not(:first-child) {
          margin-left: 1rem;

          @include max-lg {
            // margin-left: 0;
          }
        }
      }
    }

    .isText {
      color: $color-gray-2;
    }
  }
  &.isStyleDingBeauty {
    :global {
      .socialList {
        &__item {
          color: $color-secondary;
          &:hover {
            color: $color-primary;
          }
        }
      }
    }
  }
}

.metaList {
  @include list-unstyled;

  margin-bottom: 0.5rem;
  line-height: 1.5;
  // min-height: 5.5rem;

  @include max-lg {
    padding-top: 0.5rem;
    margin-top: 1rem;
    margin-bottom: 0;
    border-top: 1px solid $color-primary;
  }

  :global {
    .metaList {
      &__item {
        padding: 0.75rem 0;
        letter-spacing: 0.1em;

        @include max-lg {
          padding: 0.25rem 0;
        }

        &:not(:last-child) {
          border-bottom: 1px solid $color-line;

          @include max-lg {
            border-bottom: unset;
          }
        }
      }

      &__icon {
        padding-top: 0.15rem;
        margin-right: 0.5rem;
        color: $color-primary;
      }

      &__link {
        @include link-unstyled;

        display: inline-flex;
        font-size: 0.875rem;
        color: $color-gray-2;

        &[href] {
          &:hover, &:focus {
            color: $color-primary;

            .metaList {
              &__icon {
                color: $color-primary;
              }
            }
          }
        }
      }

      &__textIcon {
        color: $color-gray-3;
        transform: scale(0.8) translateY(5px);
      }

      &__text {
        @include unstyled;
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .metaList {
        &__item {

          &:not(:last-child) {
            border-bottom: 0;
          }
        }
      }
    }
  }
}

.dayList {
  padding: 0.25rem 0;
  line-height: 2;

  @include list-unstyled;

  :global {
    .dayList {
      &__title {
        margin-right: 0.5rem;
        font-weight: 500;
      }

      &__time {
        font-family: $font-number;
        color: $color-gray-2;
      }

      &__item {
        padding: 0 0.5rem;

        &.isActive {
          color: $color-primary;

          .dayList {
            &__time {
              color: $color-primary;
            }
          }
        }
      }
    }
  }
}

.imageList {
  position: relative;
  margin-left: calc(((-100vw + #{$container}) / 2) - #{$container-gap});

  @media (max-width: $container) {
    margin-left: -$container-gap;
  }

  @include max-lg {
    margin-bottom: 1rem;
    margin-left: 0;
  }

  :global {
    .imageList {
      &__item {
        padding-top: 56.6%;
        margin-bottom: -7px;
        background-position: center;
        background-size: cover;

        @include max-xl {
          // margin-bottom: -12px;
          height: 400px;
        }

        @include max-md {
          height: auto;
          padding-top: 56.6%;
          margin-bottom: -7px;
        }
      }
    }
    // stylelint-disable selector-class-pattern, no-descending-specificity
    .slick-arrow {
      // height: 100%;
      // width: 100px;
      position: absolute;
      top: 50%;
      // top: 0;
      z-index: 1;
      width: 70px;
      height: 70px;
      font-size: 0;
      color: #fff;
      background: transparent;
      background: rgba(#000, 25%);
      border: unset;
      opacity: 0.6;
      transition: opacity 0.3s;
      transform: translateY(-50%);
      appearance: none;

      @include max-md {
        width: 50px;
        height: 50px;
      }

      &::before {
        font-size: 2.75rem;

        @include max-md {
          font-size: 2rem;
        }
      }

      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: -1;
        content: '';
        opacity: 0;
        transition: opacity 0.3s;
      }

      &:hover {
        opacity: 1;
      }

      &:active {
        opacity: 0.4;
        transition: opacity 0s;
      }

      &.slick-prev {
        left: 0;

        &::before {
          font-family: $font-fontello;
          content: $fontello-arrow-left-helf;
        }

        &::after {
          background: linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.15) 60%);
        }

        &:hover {
          &::after {
            opacity: 0.6;
          }
        }
      }

      &.slick-next {
        right: 0;

        @media (min-width: 1920px) {
         // right: calc((100vw - 1920px) / 2);
        }

        &::before {
          font-family: $font-fontello;
          content: $fontello-arrow-right-helf;
        }

        &::after {
          background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.15) 60%);
        }

        &:hover {
          &::after {
            opacity: 0.6;
          }
        }
      }
    }
    // stylelint-enable selector-class-pattern, no-descending-specificity
  }
  &.isStyleDingBeauty {
    :global {
      .slick-arrow { 
        height: 40px;
        background: rgba(#fff, 0.6);
        &::before {
          color: $color-secondary;
          font-size: 2.35rem;
        }
        &::after {
          background: #fff;
          opacity: 0;
        }
        &:hover {
          &:after {
            opacity: 1;
          }
        }
      }
    }
  }
}

.imageListB {

  :global {
    .imageListB {
      &__item {
        position: relative;
        padding-top: 56.6%;
        cursor: pointer;
        background-position: center;
        background-size: cover;

        &::before {
          transition: background 0.1s;
        }

        &:not(.isActive) {
          &::before {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: '';
            background: rgba(#000, 0.4)
          }
        }

        &:hover {
          &::before {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: '';
            background: rgba(#000, 0.1)
          }
        }
      }
    }

    // stylelint-disable selector-class-pattern, no-descending-specificity
    .slick-arrow {
      position: absolute;
      top: 0;
      z-index: 1;
      width: 70px;
      height: calc(100% - 6px);
      font-size: 0;
      color: #fff;
      background: transparent;
      border: unset;
      opacity: 0.6;
      transition: opacity 0.3s;
      appearance: none;

      &::before {
        font-size: 2rem;
      }

      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: -1;
        content: '';
        opacity: 0;
        transition: opacity 0.3s;
      }

      &:hover {
        opacity: 1;
      }

      &:active {
        opacity: 0.4;
        transition: opacity 0s;
      }

      &.slick-prev {
        left: 0;

        &::before {
          font-family: $font-fontello;
          content: $fontello-arrow-left-helf;
        }

        &::after {
          background: linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.15) 60%);
        }

        &:hover {
          &::after {
            opacity: 0.6;
          }
        }
      }

      &.slick-next {
        right: 0;

        &::before {
          font-family: $font-fontello;
          content: $fontello-arrow-right-helf;
        }

        &::after {
          background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.15) 60%);
        }

        &:hover {
          &::after {
            opacity: 0.6;
          }
        }
      }
    }
    // stylelint-enable selector-class-pattern, no-descending-specificity
  }
}

.areaList {
  @include list-unstyled;

  :global {
    .areaList {
      &__item {
        display: flex;
        line-height: 1.75;

        &:not(:last-child) {
          margin-bottom: 0.5rem;
        }
      }

      &__title {
        flex-shrink: 0;
        width: 60px;
        font-family: $font-serif;
        font-weight: 600;
        color: $color-primary-dark;
      }

      &__text {
        @include unstyled;
      }
    }
  }
}
</style>
